import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useAuth from "src/hooks/useAuth";

import fetchUser from "src/utils/fetchUser";
import { setSession } from "src/utils/jwt";

const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const { user, is_impersonating, isInitialized, isAdmin } = useAuth();
  const { pathname } = useLocation();

  const goBackToAdmin = async () => {
    try {
      const {
        status,
        data: { access_token, menu_list },
      } = await fetchUser.post("back-to-admin");
      if (status === 200) {
        localStorage.removeItem("profile");
        localStorage.setItem("isAdmin", true);
        localStorage.setItem("menu", JSON.stringify(menu_list));
        localStorage.removeItem("isSubAdmin");
        localStorage.removeItem("isImpersonate");
        localStorage.removeItem("source_id");
        setSession(access_token);

        const impersonationSource = sessionStorage.getItem(
          "impersonationSource"
        );

        if (impersonationSource) {
          sessionStorage.removeItem("impersonationSource");
          window.location = `${window.origin}${impersonationSource}`;
        } else {
          window.location = window.origin;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const isUserLoaded = isInitialized && user && Object.keys(user).length > 0;
  if (
    !isUserLoaded ||
    !is_impersonating ||
    isAdmin ||
    Boolean(user?.is_super_admin) ||
    pathname.startsWith("/admin")
  ) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 3 }}>
      {t("impersonate.heads")} {user?.username}
      <Button
        size="small"
        variant="text"
        onClick={goBackToAdmin}
        sx={{
          textDecoration: "none",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        {t("impersonate.click")}
      </Button>
      , {t("impersonate.toGo")}
    </Alert>
  );
};

export default ImpersonationBanner;
